type Props = {
	title: string;
	content: string;
	step: number | string;
	imgSrc: string;
	imgAlt: string;
	isLast?: boolean;
};
export const StartConsultationCard: React.FC<Props> = ({ title, content, step, imgSrc, imgAlt, isLast = false }) => {
	return (
		<div
			id="start-consultation-card"
			className="w-[266px] h-[336px] relative pt-[10px] rounded-[20px] bg-white md:pt-[25px] pr-[18px] pb-[18px] pl-[18px] justify-center"
			style={{
				boxShadow: '8px 20px 80px 0px rgba(76, 152, 131, 0.19)'
			}}
		>
			{/* Circle (sunken into card) */}
			<div
				id="circle"
				className="left-0 mx-auto right-0 w-[30px] h-[30px] justify-center items-center top-[-7px] md:top-[-10px] rounded-[50%] absolute flex bg-primary-lightgreen"
			>
				<div id="circle-text" className="text-[13px] text-white font-normal font-roboto justify-center items-center flex">
					{step}
				</div>
			</div>

			{/* Content */}
			<div className="flex flex-col items-center text-center h-full">
			<div id="step-title" className="text-[18px] text-[#0D121A] font-poppins font-medium text-center w-[150px] leading-tight break-words mb-4" style={{
				display: '-webkit-box',
				WebkitLineClamp: 3,
				WebkitBoxOrient: 'vertical',
				maxHeight: '80px',
				lineHeight: '1.2em'
			}} dangerouslySetInnerHTML={{ __html: title }} />
			<div id="start-consultation-card-photo" className="w-[120px] h-[120px] border-4 border-gray-200 overflow-hidden mx-auto flex-shrink-0">
					<img src={imgSrc} alt={imgAlt} className="object-cover w-full h-full" />
				</div>
				<div id="step-text" className="text-[11px] text-[#0D2C54] font-medium font-poppins text-center w-full flex-1 flex items-center justify-center overflow-hidden mt-6" style={{
					display: '-webkit-box',
					WebkitLineClamp: 6,
					WebkitBoxOrient: 'vertical',
					lineHeight: '1.3em'
				}} dangerouslySetInnerHTML={{ __html: content }} />
			</div>
		</div>
	);
};

export default StartConsultationCard;
